var _style, _rect, _line, _text, _g, _g2, _rect2, _path, _text2, _text3, _rect3, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTraditionalTwentyAppraoch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .bg { fill: #FFFFFF; }\n    .stroke-main { stroke: #111111; stroke-width: 2; fill: none; stroke-linecap: round; stroke-linejoin: round; }\n    .fill-main { fill: #111111; }\n    .text-header { font-family: system-ui, -apple-system, sans-serif; font-weight: 700; font-size: 14px; fill: #111111; text-anchor: middle; letter-spacing: 1px; }\n    .text-label { font-family: system-ui, -apple-system, sans-serif; font-weight: 500; font-size: 11px; fill: #111111; text-anchor: middle; }\n    \n    /* Animation Framework: Global Master Loop */\n    .trad-block, .trad-arrow, .twenty-block, .twenty-arrow, .twenty-db {\n      animation-duration: 5s;\n      animation-iteration-count: infinite;\n    }\n\n    /* TRADITIONAL SIDE (Slow, heavy delays) */\n    #t-blk1 { animation-name: slowDrop1; animation-timing-function: ease-in; }\n    #t-blk2 { animation-name: slowDrop2; animation-timing-function: ease-in; }\n    #t-blk3 { animation-name: slowDrop3; animation-timing-function: ease-in; }\n    #t-arr   { stroke-dasharray: 120; stroke-dashoffset: 120; animation-name: slowArrow; animation-timing-function: linear; }\n\n    @keyframes slowDrop1 { 0%, 5% { transform: translateY(-20px); opacity: 0; } 15%, 85% { transform: translateY(0); opacity: 0.4; } 92%, 100% { opacity: 0; } }\n    @keyframes slowDrop2 { 0%, 20% { transform: translateY(-20px); opacity: 0; } 30%, 85% { transform: translateY(0); opacity: 0.4; } 92%, 100% { opacity: 0; } }\n    @keyframes slowDrop3 { 0%, 35% { transform: translateY(-20px); opacity: 0; } 45%, 85% { transform: translateY(0); opacity: 1; } 92%, 100% { opacity: 0; } }\n    @keyframes slowArrow { 0%, 48% { stroke-dashoffset: 120; } 70%, 85% { stroke-dashoffset: 0; } 92%, 100% { stroke-dashoffset: 120; } }\n\n    /* TWENTY HQ SIDE (Snappy, spring/elastic behavior) */\n    #tw-blk { animation-name: fastSnap; animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275); }\n    #tw-arr { stroke-dasharray: 120; stroke-dashoffset: 120; animation-name: fastArrow; animation-timing-function: cubic-bezier(0.19, 1, 0.22, 1); }\n    #tw-db  { transform-origin: 600px 315px; animation-name: springDB; animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.5); }\n\n    @keyframes fastSnap { 0%, 5% { transform: scale(0.6); opacity: 0; } 12%, 85% { transform: scale(1); opacity: 1; } 92%, 100% { opacity: 0; } }\n    @keyframes fastArrow { 0%, 10% { stroke-dashoffset: 120; } 22%, 85% { stroke-dashoffset: 0; } 92%, 100% { stroke-dashoffset: 120; } }\n    @keyframes springDB { 0%, 18% { transform: scale(0); opacity: 0; } 30%, 85% { transform: scale(1); opacity: 1; } 92%, 100% { transform: scale(0); opacity: 0; } }\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "bg",
    width: 800,
    height: 450
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 40,
    x2: 400,
    y2: 410,
    stroke: "#111111",
    strokeWidth: 1,
    strokeDasharray: "6 8",
    opacity: 0.15
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "text-header",
    x: 200,
    y: 70
  }, "TRADITIONAL FLOW")), /*#__PURE__*/React.createElement("g", {
    id: "traditional-elements"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "t-blk1",
    className: "trad-block"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "stroke-main",
    x: 130,
    y: 110,
    width: 140,
    height: 32,
    rx: 4
  }), /*#__PURE__*/React.createElement("text", {
    className: "text-label",
    x: 200,
    y: 130
  }, "1. Local Code Change"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "t-blk2",
    className: "trad-block"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "stroke-main",
    x: 130,
    y: 155,
    width: 140,
    height: 32,
    rx: 4
  }), /*#__PURE__*/React.createElement("text", {
    className: "text-label",
    x: 200,
    y: 175
  }, "2. Generate Migration"))), /*#__PURE__*/React.createElement("g", {
    id: "t-blk3",
    className: "trad-block"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "stroke-main",
    x: 130,
    y: 200,
    width: 140,
    height: 32,
    rx: 4,
    fill: "white",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("text", {
    className: "text-label",
    x: 200,
    y: 220,
    style: {
      fontWeight: 700
    }
  }, "3. Build &amp; Deploy")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "t-arr",
    className: "stroke-main trad-arrow",
    d: "M200,245 C200,280 200,285 200,310 M195,303 L200,310 L205,303"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "text-label",
    x: 200,
    y: 345,
    opacity: 0.5
  }, "Latency: Minutes"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "text-header",
    x: 600,
    y: 70
  }, "TWENTY RUNTIME")), /*#__PURE__*/React.createElement("g", {
    id: "twenty-elements"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tw-blk",
    className: "twenty-block"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "stroke-main",
    x: 530,
    y: 125,
    width: 140,
    height: 45,
    rx: 6,
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("text", {
    className: "text-label",
    x: 600,
    y: 151,
    fill: "white",
    style: {
      fontWeight: 700
    }
  }, "Metadata Event")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "tw-arr",
    className: "stroke-main twenty-arrow",
    d: "M600,185 L600,270 M595,263 L600,270 L605,263",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "tw-db",
    className: "twenty-db"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "stroke-main",
    d: "M570,290 C570,282 630,282 630,290 M570,290 C570,298 630,298 630,290 M570,302 C570,310 630,310 630,302 M570,314 C570,322 630,322 630,314 M570,290 L570,314 M630,290 L630,314",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("text", {
    className: "text-label",
    x: 600,
    y: 345,
    style: {
      fontWeight: 700
    }
  }, "Live Update Engine")), /*#__PURE__*/React.createElement("text", {
    className: "text-label",
    x: 600,
    y: 365,
    style: {
      fill: "#111111",
      fontWeight: 700
    }
  }, "Latency: Instant (0ms)")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraditionalTwentyAppraoch);
export default __webpack_public_path__ + "static/media/traditional-twenty-appraoch.3546bd2ca34b0b1030c0c92b538192e9.svg";
export { ForwardRef as ReactComponent };